<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part01">
<div class="partHead" id="ph01">
<h2 class="partNumber"><span class="xrefInternal"><a href="#/text/9780062016706_Contents#part_01"><span class="bold">[ PART ONE ]</span></a></span></h2>
<div class="partEpigraph" style="margin-left: 5%;">
<p class="partEpigraphText"><em class="italic">Nothing that is worth doing can be achieved in our lifetime; therefore we must be saved by hope. Nothing which is true or beautiful or good makes complete sense in any immediate context of history; therefore we must be saved by faith. Nothing we do, however virtuous, can be accomplished alone; therefore we must be saved by love.</em></p>
<p class="partEpigraphSource" style="margin-left: 0%;">R<span class="smallCaps">EINHOLD</span> N<span class="smallCaps">IEBUHR</span></p></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062016706_Part_1.vue?50750195